const ITEMS_LIST_REQUEST = "ITEMS_LIST_REQUEST";
const ITEMS_LIST_SUCCESS = "ITEMS_LIST_SUCCESS";
const ITEMS_LIST_FAILURE = "ITEMS_LIST_FAILURE";

const ITEM_DETAILS_REQUEST = "ITEM_DETAIlS_REQUEST";
const ITEM_DETAILS_SUCCESS = "ITEM_DETAIlS_SUCCESS";
const ITEM_DETAILS_FAILURE = "ITEM_DETAIlS_FAILURE";

const ITEM_DELETE_REQUEST = "ITEM_DELETE_REQUEST";
const ITEM_DELETE_SUCCESS = "ITEM_DELETE_SUCCESS";
const ITEM_DELETE_FAILURE = "ITEM_DELETE_FAILURE";

const ITEM_CREATE_REQUEST = "ITEM_CREATE_REQUEST";
const ITEM_CREATE_SUCCESS = "ITEM_CREATE_SUCCESS";
const ITEM_CREATE_FAILURE = "ITEM_CREATE_FAILURE";
const ITEM_CREATE_RESET = "ITEM_CREATE_RESET";

const ITEM_UPDATE_REQUEST = "ITEM_UPDATE_REQUEST";
const ITEM_UPDATE_SUCCESS = "ITEM_UPDATE_SUCCESS";
const ITEM_UPDATE_FAILURE = "ITEM_UPDATE_FAILURE";
const ITEM_UPDATE_RESET = "ITEM_UPDATE_RESET";

const ITEM_CREATE_REVIEW_REQUEST = "ITEM_CREATE_REVIEW_REQUEST";
const ITEM_CREATE_REVIEW_SUCCESS = "ITEM_CREATE_REVIEW_SUCCESS";
const ITEM_CREATE_REVIEW_FAILURE = "ITEM_CREATE_REVIEW_FAILURE";
const ITEM_CREATE_REVIEW_RESET = "ITEM_CREATE_REVIEW_RESET";

const ITEMS_TOP_REQUEST = "ITEMS_TOP_REQUEST";
const ITEMS_TOP_SUCCESS = "ITEMS_TOP_SUCCESS";
const ITEMS_TOP_FAILURE = "ITEMS_TOP_FAILURE";

export {
  ITEMS_LIST_REQUEST,
  ITEMS_LIST_SUCCESS,
  ITEMS_LIST_FAILURE,
  ITEM_DETAILS_REQUEST,
  ITEM_DETAILS_SUCCESS,
  ITEM_DETAILS_FAILURE,
  ITEM_DELETE_REQUEST,
  ITEM_DELETE_SUCCESS,
  ITEM_DELETE_FAILURE,
  ITEM_CREATE_REQUEST,
  ITEM_CREATE_SUCCESS,
  ITEM_CREATE_FAILURE,
  ITEM_CREATE_RESET,
  ITEM_UPDATE_REQUEST,
  ITEM_UPDATE_SUCCESS,
  ITEM_UPDATE_FAILURE,
  ITEM_UPDATE_RESET,
  ITEM_CREATE_REVIEW_REQUEST,
  ITEM_CREATE_REVIEW_SUCCESS,
  ITEM_CREATE_REVIEW_FAILURE,
  ITEM_CREATE_REVIEW_RESET,
  ITEMS_TOP_REQUEST,
  ITEMS_TOP_SUCCESS,
  ITEMS_TOP_FAILURE,
};
